import api from './api';

export const conversationsService = {
  async getConversations(params = {}) {
    const response = await api.get('/conversations', { params });
    return response.data;
  },

  async getConversation(id) {
    const response = await api.get(`/conversations/${id}`);
    return response.data;
  },

  async createConversation(data) {
    const response = await api.post('/conversations', data);
    return response.data;
  },

  async updateConversation(id, data) {
    const response = await api.put(`/conversations/${id}`, data);
    return response.data;
  },

  async deleteConversation(id) {
    const response = await api.delete(`/conversations/${id}`);
    return response.data;
  },

  async getMessages(conversationId, params = {}) {
    const response = await api.get(`/conversations/${conversationId}/messages`, { params });
    return response.data;
  },

  async archiveConversation(id) {
    const response = await api.post(`/conversations/${id}/archive`);
    return response.data;
  },

  async unarchiveConversation(id) {
    const response = await api.post(`/conversations/${id}/unarchive`);
    return response.data;
  },

  async archiveAll() {
    const response = await api.post('/conversations/archive-all');
    return response.data;
  },

  async getStats() {
    const response = await api.get('/conversations/stats');
    return response.data;
  },
};

export default conversationsService;
